import { DOC_MOVE_WS_EVENT, DOC_MOVE_CLEAR_ALERT } from '../actionTypes/docMoveActionTypes';

export const docMoveWsEvent = (event: any) => ({
    type: DOC_MOVE_WS_EVENT,
    payload: event
});

export const clearDocMoveAlert = () => ({
    type: DOC_MOVE_CLEAR_ALERT
});
